// src/components/ModalImageHeader.js
import React, { useRef, useState, useCallback, useEffect } from 'react';
import Cropper from 'react-easy-crop';
import './ModalImageHeader.css';

export default function ModalImageHeader({ initialImageUrl = '', onCancel, onConfirm }) {
  const fileInputRef = useRef(null);
  const containerRef = useRef(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(initialImageUrl);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // When file selected, set preview + reset
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (previewUrl && previewUrl !== initialImageUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setSelectedFile(file);
    const newUrl = URL.createObjectURL(file);
    setPreviewUrl(newUrl);
    setZoom(1);
    setCrop({ x: 0, y: 0 });
    setCroppedAreaPixels(null);
  };

  // Crop complete callback
  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  // Ensure image loads completely initially
  const onMediaLoaded = useCallback((img) => {
    if (!containerRef.current) return;
    const contWidth = containerRef.current.clientWidth;
    const contHeight = (contWidth * 2) / 5;
    const imageAspect = img.width / img.height;
    const containerAspect = 5 / 2;
    let calculatedMinZoom;
    if (imageAspect > containerAspect) {
      calculatedMinZoom = contHeight / img.height;
    } else {
      calculatedMinZoom = contWidth / img.width;
    }
    setZoom(calculatedMinZoom);
  }, []);

  // Manual zoom slider handler
  const handleZoomChange = (e) => {
    const z = parseFloat(e.target.value);
    setZoom(z);
  };

  // Cleanup URL on unmount
  useEffect(() => {
    return () => {
      if (previewUrl && previewUrl !== initialImageUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl, initialImageUrl]);

  return (
    <div className="modalProfOverlay">
      <div className="modalProfCard">

        {/* Selector de imagen */}
        <div className="header-image-select">
          <button
            className="change-image-button"
            onClick={() => fileInputRef.current.click()}
          >
            Seleccionar Imagen
          </button>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </div>

        {/* Área de recorte */}
        <div className="modalProfHeaderImageEdit" ref={containerRef}>
          {previewUrl ? (
            <>
              <Cropper
                image={previewUrl}
                crop={crop}
                zoom={zoom}
                minZoom={0.2}
                maxZoom={5}
                aspect={5 / 2}
                restrictPosition={false}
                style={{ mediaStyle: { objectFit: 'contain' } }}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
                onMediaLoaded={onMediaLoaded}
              />
              <div className="zoom-slider-container">
                <input
                  type="range"
                  min="0.2"
                  max="5"
                  step="0.01"
                  value={zoom}
                  onChange={handleZoomChange}
                  className="zoom-slider"
                />
              </div>
            </>
          ) : (
            <div className="placeholder">No hay imagen seleccionada</div>
          )}
        </div>

        {/* Botones de acción */}
        <div className="modalImageFooter">
          <button className="btn-cancel" onClick={onCancel}>
            Cancelar
          </button>
          <button
            className="btn-accept"
            onClick={() => onConfirm({ file: selectedFile, croppedArea: croppedAreaPixels, zoom, crop })}
            disabled={!croppedAreaPixels}
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}